// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var TipBoxes = require("../../../reason/clients/components/TipBoxes.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Form__Checkbox = require("../../../uikit/reason/atoms/Form/Form__Checkbox.bs.js");
var GeocodingError = require("../propertyForms/Geocoding/GeocodingError.bs.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var CityZipAutocompleteV5 = require("../propertyForms/CityZipAutocompleteV5.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
var PropertyMlsValidationStatusComponents = require("../propertyForms/Geocoding/PropertyMlsValidationStatusComponents.bs.js");
var PropertyAddressValidationDuplicatePropertyError = require("../propertyForms/Geocoding/PropertyAddressValidationDuplicatePropertyError.bs.js");
var PropertyWizardFormRelay__Validators__KeyFacts__Address = require("./PropertyWizardFormRelay__Validators__KeyFacts__Address.bs.js");
var PropertyWizardRelayKeyFactsStreetAddress_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.bs.js");
var PropertyWizardRelayKeyFactsStreetAddress_formState_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.bs.js");

var convertFragment = PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

var FormStateFragment_localDraftGeocodingStatus_decode = PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.Utils.localDraftGeocodingStatus_decode;

var FormStateFragment_localDraftGeocodingStatus_fromString = PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

var FormStateFragment_localDraftMlsStatus_decode = PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.Utils.localDraftMlsStatus_decode;

var FormStateFragment_localDraftMlsStatus_fromString = PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.Utils.localDraftMlsStatus_fromString;

var FormStateFragment = {
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString,
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__KeyFacts__StreetAddress(props) {
  var duplicatedProperty = props.duplicatedProperty;
  var stepHasBeenTouched = props.stepHasBeenTouched;
  var draft = use(props.draft);
  var formState = use$1(props.formState);
  var match = PropertyWizardFormRelay.Context.use();
  var updateDraftProperty = PropertyWizardFormRelay.useUpdateDraftProperty();
  var streetAddressValid = PropertyWizardFormRelay__Validators__KeyFacts__Address.StreetAddress.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  var tmp;
  if (streetAddressValid !== undefined) {
    if (streetAddressValid.NAME === "Invalid") {
      var match$1 = streetAddressValid.VAL;
      tmp = match$1 === "missingAddress" ? ({
            NAME: "Error",
            VAL: "is required"
          }) : (
          match$1 === "propertyAlreadyOnMls" ? ({
                NAME: "Error",
                VAL: ""
              }) : (
              match$1 === "mlsStatusCheckFailed" ? ({
                    NAME: "Error",
                    VAL: "We had a problem validating your address."
                  }) : (
                  match$1 === "outsideChapterBoundaries" ? ({
                        NAME: "Error",
                        VAL: "This property is outside of the chapter boundaries."
                      }) : (
                      match$1 === "missingCity" ? undefined : ({
                            NAME: "Error",
                            VAL: ""
                          })
                    )
                )
            )
        );
    } else {
      tmp = "Valid";
    }
  } else {
    tmp = undefined;
  }
  var addressProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (current, value) {
            var newrecord = Caml_obj.obj_dup(current);
            newrecord.address = value;
            return newrecord;
          })
      }, stepHasBeenTouched, draft.draftProperty.address, tmp);
  var areaOption = Core__Option.map(draft.draftProperty.selectedArea, (function (area) {
          return {
                  id: area.id,
                  label: area.label
                };
        }));
  var areaProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (current, value) {
            var newrecord = Caml_obj.obj_dup(current);
            newrecord.selectedArea = value !== undefined ? ({
                  id: value.id,
                  label: value.label
                }) : undefined;
            return newrecord;
          })
      }, stepHasBeenTouched, areaOption, PropertyWizardFormRelay__Validators__KeyFacts__Address.CityOrZip.useIsValid(draft.fragmentRefs, formState.fragmentRefs));
  var loading;
  loading = formState.geocodingStatus === "Called" || formState.mlsStatus === "Called" ? true : false;
  var hideAddress = Core__Option.getOr(draft.draftProperty.hideAddress, false);
  var tmp$1;
  if (streetAddressValid !== undefined && typeof streetAddressValid === "object" && streetAddressValid.NAME === "Invalid") {
    var match$2 = streetAddressValid.VAL;
    tmp$1 = match$2 === "geocodingFailed" ? JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(GeocodingError.make, {
                  reason: "UnableToGeocode"
                }),
            className: "mt-4"
          }) : (
        match$2 === "propertyAlreadyOnMls" ? (
            match.mode === "New" ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(PropertyMlsValidationStatusComponents.AlreadyOnMlsCannotBeBroadcast.make, {}),
                    className: "mt-4"
                  }) : null
          ) : (
            match$2 === "duplicateListing" ? (
                duplicatedProperty !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(PropertyAddressValidationDuplicatePropertyError.make, {
                              property: Caml_option.valFromOption(duplicatedProperty)
                            }),
                        className: "mt-4"
                      }) : null
              ) : (
                match$2 === "outsideChapterBoundaries" ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(GeocodingError.make, {
                              reason: "OutsideChapterBoundaries"
                            }),
                        className: "mt-4"
                      }) : null
              )
          )
      );
  } else {
    tmp$1 = null;
  }
  return JsxRuntime.jsxs(FormV5.FormSection.make, {
              tipbox: addressProps.focused ? Caml_option.some(TipBoxes.PropertyWizard.streetAddress) : undefined,
              children: [
                JsxRuntime.jsxs(CssGrid.Grid, {
                      children: [
                        JsxRuntime.jsxs(CssGrid.Cell, {
                              width: 12,
                              widthMd: 6,
                              children: [
                                JsxRuntime.jsxs(View__Jsx3.make, {
                                      flexGrow: 1,
                                      position: "relative",
                                      children: [
                                        JsxRuntime.jsx(Form__Input.make, {
                                              labelText: "Street Address",
                                              onChange: (function ($$event) {
                                                  var text = $$event.currentTarget.value;
                                                  addressProps.onChange(text);
                                                }),
                                              onBlur: (function (param) {
                                                  updateDraftProperty(function (current) {
                                                        var newrecord = Caml_obj.obj_dup(current);
                                                        newrecord.addressToGeocode = addressProps.value;
                                                        return newrecord;
                                                      });
                                                  addressProps.onBlur();
                                                }),
                                              onFocus: (function (param) {
                                                  addressProps.onFocus();
                                                }),
                                              status: addressProps.status,
                                              value: addressProps.valueAsString
                                            }),
                                        loading ? JsxRuntime.jsx(PropertyWizardFormRelay__Elements.LoadingSpinner.make, {}) : null
                                      ]
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(Form__Components.FieldError.make, {
                                            valid: addressProps.valid
                                          })
                                    })
                              ]
                            }),
                        JsxRuntime.jsxs(CssGrid.Cell, {
                              width: 12,
                              widthMd: 6,
                              children: [
                                JsxRuntime.jsx(Form__Label.make, {
                                      labelText: "City or Zip"
                                    }),
                                JsxRuntime.jsx(CityZipAutocompleteV5.make, {
                                      value: Caml_option.some(areaProps.value),
                                      onChange: (function (value) {
                                          areaProps.onChange(value);
                                        }),
                                      onBlur: (function (param) {
                                          areaProps.onBlur();
                                        }),
                                      status: areaProps.status
                                    }),
                                JsxRuntime.jsx(Form__Components.FieldError.make, {
                                      valid: areaProps.valid
                                    })
                              ]
                            }),
                        JsxRuntime.jsx(CssGrid.Cell, {
                              width: 12,
                              widthMd: 6,
                              children: Caml_option.some(JsxRuntime.jsx(Form__Checkbox.make, {
                                        onChange: (function (_e) {
                                            updateDraftProperty(function (c) {
                                                  var newrecord = Caml_obj.obj_dup(c);
                                                  newrecord.hideAddress = !hideAddress;
                                                  return newrecord;
                                                });
                                          }),
                                        name: "hideAddress",
                                        checked: hideAddress,
                                        label: "Hide address from others"
                                      }))
                            })
                      ]
                    }),
                tmp$1
              ]
            });
}

var Components;

var FormSection;

var TextInputField;

var Grid;

var Cell;

var Checkbox;

var TipBoxes$1;

var Validators;

var FormElements;

var FormUtils;

var make = PropertyWizardRelay__KeyFacts__StreetAddress;

exports.Components = Components;
exports.FormSection = FormSection;
exports.TextInputField = TextInputField;
exports.Grid = Grid;
exports.Cell = Cell;
exports.Checkbox = Checkbox;
exports.TipBoxes = TipBoxes$1;
exports.Validators = Validators;
exports.FormElements = FormElements;
exports.FormUtils = FormUtils;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* FormV5 Not a pure module */
